module.exports = __webpack_public_path__ + "img/paymentBadgeCloudV2.eb38c2c.png";